export const getDeliveryType = (
  isRegular: boolean,
  isColdchain: boolean,
): string => {
  if (isRegular) return 'Regular Delivery';
  if (isColdchain) return 'Cold Chain (2-8°C)';
  return '-';
};

export const getDeliveryTypeShort = (
  isRegular: boolean,
  isColdchain: boolean,
): string => {
  if (isRegular) return 'Regular';
  if (isColdchain) return 'Cold Chain';
  return '-';
};
